export default __webpack_public_path__ + "static/media/chest3.925a5c93.png";